import { IEventRegistrationDetails } from '../../../../../../shared/types/eventTypes';

export const getInitialMultiRegistrationEvents = (eventRegistrationDetails: IEventRegistrationDetails) => {
  return (eventRegistrationDetails.multiRegistrationEvents || []).map(({ event }) => ({
    id: event.id,
    checked: true
  }));
};
